// src/admindashboardutils/components/QueueList.jsx
import React from "react";

const QueueList = ({ queueData }) => (
  <div className="bg-white rounded-lg p-4 shadow-md h-full">
    <h3 className="text-lg font-medium text-gray-700 mb-4">Queue</h3>
    <div className="bg-red-50 rounded-md p-3 flex justify-between items-center mb-3">
      <span className="font-semibold text-gray-800">0 Calls Waiting</span>
      <span className="text-red-500 text-xl">!</span>
    </div>
    <div className="flex flex-col space-y-2">
      {queueData.map((agent, index) => (
        <div
          key={index}
          className="flex justify-between items-center border-b border-gray-200 py-1"
        >
          <span className="text-gray-700">{agent.name}</span>
          <span className={`${agent.color} font-medium`}>{agent.status}</span>
        </div>
      ))}
    </div>
  </div>
);

export default QueueList;